import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Events, NavParams } from "ionic-angular";
import { PainSiteService } from "../../pain-site-card/pain-site.service";
import { NewWoundService } from "../new-wound.service";

@Component({
  selector: "new-wound-location",
  templateUrl: "new-wound-location.html",
})
export class NewWoundLocationComponent {
  painService: PainSiteService;
  sidebar: any;
  canvas: any;
  config: any;
  isHopeAssessment: boolean;
  shouldShowWoundToolMigrationWarning: boolean;
  shouldShowOtherWoundTypeWarning: boolean;

  constructor(
    private newWoundService: NewWoundService,
    public translatePipe: TranslateService,
    public events: Events,
    params: NavParams
  ) {
    let data = params.data;
    this.config = data.config;
    this.painService = this.newWoundService.getPainService();
  }

  ngOnInit(): void {
    for (let i = 0; i < this.config.tabs.length; i++) {
      if (this.config.tabs[i].locationOfWound) {
        for (let j = 0; j < this.config.tabs[i].locationOfWound.length; j++) {
          if (this.config.tabs[i].locationOfWound[j].sidebar)
            this.sidebar = this.config.tabs[i].locationOfWound[j].sidebar;
          if (this.config.tabs[i].locationOfWound[j].backgrounds)
            this.canvas = this.config.tabs[i].locationOfWound[j].backgrounds;
        }
      }
    }
    this.events.subscribe("hopeDataChanged", (data) => {
      if (data) {
        this.isHopeAssessment = data.isHopeAssessment;
      }
    });
  }

  updateCardData(data) {
    if (
      this.isHopeAssessment &&
      data &&
      data.stepOneSidebarData &&
      data.stepOneSidebarData.woundType === "other"
    ) {
      this.shouldShowOtherWoundTypeWarning = true;
    } else {
      this.shouldShowOtherWoundTypeWarning = false;
    }
    this.newWoundService.setCurrentPointData(data);
    this.newWoundService.updateOrPushCurrentPoint(data);
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/new-wound-site-card/new-wound-location/new-wound-location.ts